import { getStatisticHeader } from "src/helpers/statistic-list-item";
import { capitalizeFirstLetter } from "src/utils/methods";
import { addHeaderToArray } from "../../addHeaderToArray";

export const addSentimentAnalysisToGridElements = (
  newGridElements,
  newHiddenGridElements,
  savedTemplate,
  templateApplied,
  campaigns,
  aggregation,
  formatMessage,
  campaignId,
  sentimentValues,
) => {
  if (!sentimentValues) return;

  const isSuitableForSelectedMode =
    (aggregation && campaignId !== "aggregated") ||
    (!aggregation && campaignId === "aggregated");

  const isSingleCampaign = Object.keys(campaigns).length === 1;
  const headerDepth = campaignId !== "aggregated" && !isSingleCampaign ? 3 : 2;

  addHeaderToArray(
    formatMessage({
      id: "ws_sentiment_analysis_summary",
      defaultMessage: "Sentiment analysis - Summary",
    }),
    !isSuitableForSelectedMode ? newGridElements : newHiddenGridElements,
    headerDepth,
    `sentiment-analysis-${campaignId}`,
    savedTemplate,
    templateApplied,
    "sentiment-analysis",
  );

  Object.entries(sentimentValues).forEach((item) => {
    const [provider, value] = item;

    const element = {
      key: `${provider}-${campaignId}`,
      label: `sentiment-analysis-${provider}-${campaignId}`,
      name: capitalizeFirstLetter(getStatisticHeader(provider)),
      value,
      gridBoxType: "sentiment-analysis",
      section: `sentiment-analysis-${campaignId}`,
      campaignId,
    };

    // applying saved template

    if (
      (!aggregation && campaignId === "aggregated") ||
      (aggregation && campaignId !== "aggregated")
    ) {
      newHiddenGridElements.push(element);
    } else if (savedTemplate?.length && !templateApplied) {
      if (savedTemplate.find((item) => item.i === element.label)) {
        newGridElements.push(element);
      } else {
        newHiddenGridElements.push(element);
      }
    } else {
      newGridElements.push(element);
    }
  });
};
